import { gql } from "apollo-server-micro";

export const GET_PURCHASE = gql`
  query getPurchase(
    $_id: ID! # PROPERTIES HERE
  ) {
    getPurchase(
      _id: $_id # PROPERTIES HERE
    ) {
      _id
      referenceId
      userId
      resourceId
      type
      pricePayed
      discountApplied
      # PROPERTIES HERE
    }
  }
`;

export const GET_ALL_PURCHASES = gql`
  query getAllPurchases {
    getAllPurchases {
      _id
      referenceId
      userId
      resourceId
      type
      pricePayed
      discountApplied
      # PROPERTIES HERE
    }
  }
`;

/* BOILERPLATER_INJECT_QUERY */
export const GET_USER_PURCHASES = gql`
  query getUserPurchases {
    getUserPurchases {
      _id
      referenceId
      userId
      resourceId
      type
      pricePayed
      discountApplied
      dateApplied
      createdDate
      resource {
        _id
        brand
        model
        year
        thumbs
      }
      isRenew
    }
  }
`;
